import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";

import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { AuthProvider } from "./AuthContext";
import AppLayout from "./Component/AppLayout";
import Login from "./Component/Login";
import Logout from "./Component/Logout";
import Home from "./Component/Home";
import Customer from "./Component/Customer";
import Stock from "./Component/Stock";
import Sales from "./Component/Sales";
import Loan from "./Component/Loan";
import Salary from "./Component/Salary";
import Expenses from "./Component/Expenses";
import History from "./Component/History";
import Lager from "./Component/Lager";
import InstallPWA from "./Component/InstallPWA";

const App = () => (
  <AuthProvider>
    <InstallPWA />
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route element={<AppLayout />}>
          <Route path="/home" element={<Home />} />
          <Route path="/customers" element={<Customer />} />
          <Route path="/stocks" element={<Stock />} />
          <Route path="/list" element={<Lager />} />
          <Route path="/sales" element={<Sales />} />
          <Route path="/loans" element={<Loan />} />
          <Route path="/salary" element={<Salary />} />
          <Route path="/expenses" element={<Expenses />} />
          <Route path="/history" element={<History />} />
          <Route path="/logout" element={<Logout />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  </AuthProvider>
);

export default App;
